export default __webpack_public_path__ + "static/media/AcceptIcon.c46863a8.svg";